import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
  children?: ReactNode;
  className?: string;
}

const SlidingFixedChild = ({ children, className }: Props) => {
  return <div className={classNames('sliding-fixed-child', className)}>{children}</div>;
};

export default SlidingFixedChild;
